import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { WELCOME_TUTORIAL_DIALOG_OPTIONS } from '../utils/constant';
import { AccountService } from '../../../../shared/services/account.service';
import { ProcessQueueRequestAction } from '../../../../shared/utils/enums';
import { HttpQueueService } from '../../../../shared/services/http-queue.service';

@Component({
  selector: 'app-welcome-tutorial-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    CommonModule,
    FormsModule,
    MatCheckboxModule,
  ],
  templateUrl: './welcome-tutorial-dialog.component.html',
  styleUrl: './welcome-tutorial-dialog.component.scss',
})
export class WelcomeTutorialDialogComponent {
  optOutCheck = false; // whether this user has opted out of having the automatic intro tutorial pop up on login
  readonly dialogRef = inject(MatDialogRef<WelcomeTutorialDialogComponent>);
  private readonly data = inject<any>(MAT_DIALOG_DATA);
    protected accountService = inject(AccountService);
    private readonly httpQueueService = inject(HttpQueueService);

  ngOnInit(): void {
    this.optOutCheck = this.accountService.otherAccountSettings().optOutWelcomePopup;
  }

  readonly welcomeTutorialDialogOptions = WELCOME_TUTORIAL_DIALOG_OPTIONS;

  /**
   * handles button action for "Ok" button of intro tutorial popup dialog if opt out preference is different from current value, queue request to the backend to update this preference
   */
  welcomePopUpOkAction(): void {
    this.accountService.otherAccountSettings.update((state) => {
      state.optOutWelcomePopup = this.optOutCheck;
      return state;
    })
    this.httpQueueService.enqueueRequest(ProcessQueueRequestAction.SaveWelcomePopupPreference);
    this.dialogRef.close();
  }
}
